// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Card, CardContent, Checkbox, FormControlLabel, Button , Radio, RadioGroup } from "@mui/material";
// import './style.css'
// import "../style.css"
// import anmolLogo from "../../assets/images/anmol_logo_transparent.png"
// import { ToastContainer, toast } from "react-toastify";

// export default function CustomerType() {
//   const toastId= React.useRef(null)
//    const [selectedOption, setSelectedOption] = useState("");
//    const [selectedCard, setSelectedCard] = useState(""); 
//   const [msme, setMsme] = useState(false);
//   const [fssi, setFssi] = useState(false);
//   const [others, setOthers] = useState(false);
//   const [noSelected, setNoSelected]= useState("");
//   const navigate = useNavigate();

//   // Load values from localStorage when the component mounts
 

//   // Update localStorage when state changes

//   const handleMsmeChange=(e)=>{
//     setMsme(e.target.checked);
//   }
//   const handleFssiChange=(e)=>{
//     setFssi(e.target.checked)
//   }

//   const handleCardSelection = (card) => {
//     setSelectedCard(card);
//   };
 

//   const handleProceed = () => {
//       if(selectedCard===""){
//         if(!toast.isActive(toastId.current)){
//           toastId.current= toast.warning("Please select a customer type",{
//                     className: "small-toast"
//                   })
//         }
//         return;
//       }else{
//         localStorage.setItem("customer_type",selectedCard);
//         navigate("/customer/registration-form")
//         return;
//       }
//   };

//   return (
//     <>
//     <ToastContainer/>
//     <div className="container">
//     <div className="image-container">
//       <img src={anmolLogo} alt="Business Image" className="business-image" />
//     </div>

//     <h2 className="title">Select Your Type:</h2>

//     <div className="checkbox-cards-container">
//       {/* First Card: Business Registrations */}
//       <div className={`checkbox-card `}>
//         <FormControlLabel
//           control={
//             <Radio
//               sx={{ color: "#01040a" }}
//               checked={selectedCard==="distributor"}
//               onChange={() => handleCardSelection("distributor")}
//             />
//         }
//         label={<span className="checkbox-label">Distributor</span>}
//         />
       
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "railway_distributor"}
//               onChange={() => handleCardSelection("railway_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">Railway Distributor</span>}
//         />
//       </div>

//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "super_stockist"}
//               onChange={() => handleCardSelection("super_stockist")}
//             />
//           }
//           label={<span className="checkbox-label">Super Stockist</span>}
//         />
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "sub_distributor"}
//               onChange={() => handleCardSelection("sub_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">Sub Distributor</span>}
//         />
//       </div>

//       <div className={`checkbox-card `}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "sitting_sub_distributor"}
//               onChange={() => handleCardSelection("sitting_sub_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">Sitting Sub Distributor</span>}
//         />
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "smt_distributor"}
//               onChange={() => handleCardSelection("smt_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">SMT Distributor</span>}
//         />
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "modern_trade_cpc"}
//               onChange={() => handleCardSelection("modern_trade_cpc")}
//             />
//           }
//           label={<span className="checkbox-label">Modern Trade/ CPC/ Ecommerce</span>}
//         />
//       </div>



//       {/* Second Card: Others */}
//       {/* <div className={`checkbox-card ${selectedCard === "others" ? "active" : ""}`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "others"}
//               onChange={() => handleCardSelection("others")}
//             />
//           }
//           label={<span className="checkbox-label">Others</span>}
//         />
//       </div> */}
//     </div>

//     <Button variant="contained" sx={{ color: "ivory", marginTop: "30px" }} onClick={handleProceed} color="primary" className="proceed-button">
//       Proceed
//     </Button>
//   </div>
//     </>
  
//   );
// }


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormControlLabel, Checkbox, Button , Radio} from "@mui/material";
import "../style.css";
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import { ToastContainer, toast } from "react-toastify";
import { fetchEditable } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";

export default function CustomerEditValidationFinal() {
  const toastId = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [refID,setRefID]= useState(localStorage.getItem("reference_id")|| "");
  const navigate = useNavigate();
  const [disableMarket, setDisabledMarket]= useState('');
  const [customerType,setCustomerType]= useState('');
  const [isActive,setIsActive]= useState(false);

//    const [formValues, setFormValues] = useState({
       
//         trade_name: { value: '', error: false }, // Trade Name(as per gst)*
//         address: { value: '', error: false }, // Address(to be registered as per GST)*
//         typeOfFirm: { value: '', error: false }, // Type of Firm/Company*
//         cin: { value: '', error: false }, // CIN (if applicable)
//         postal_code: { value: '', error: false }, // Postal Code
//         mca_roc_status: { value: '', error: false }, // MCA/ROC status (for Co/LLP)
//         latest_co_status: { value: '', error: false }, // Latest Co Status (If MCA/ROC is Active)
//         city: { value: '', error: false }, // City*
//         region: { value: '', error: false }, // Region
//         state: { value: '', error: false }, // State*
//         pin_code: { value: '', error: false }, // Pin Code*
//         website: { value: '', error: false }, // Website
//         telephone: { value: '', error: false }, // Telephone
//         email: { value: '', error: false }, // Email Address*
//         proprietor_name: { value: '', error: false }, 
//         proprietor_email: { value: '' , error: false}, 
//         proprietor_mobile: { value: '' , error: false}, 
//         pan: { value: '', error: false }, 
//         contact_person: { value: '' , error: false}, // Name of Contact Person*
//         contact_person_email: { value: '', error: false }, // Mobile Number*
//         contact_person_mobile: { value: '', error: false }, // Telephone Number*
//         // nature_of_business: { value: [],error: false }, // Nature of Business*
//         // business_category: { value: [],error: false }, 
//         msme_registration_status: { value: '',error: false }, // MSME Registration Status.
//         msme_registration_no: { value: '',error: false }, // MSME Registration no.
//         msme_category: { value: '',error: false }, // MSME Category
//         msme_type: { value: '',error: false }, // MSME Type
//         fssai_registration_status: { value: '',error: false }, // FSSI Registration Status.
//         fssai_regn_no: { value: '',error: false }, // FSSI Regn No
//         fssai_valid_till: { value: '',error: false }, // FSSI Valid Till (dd-mm-yyyy)
//         gstn: { value: '',error: false }, // GSTN No*.
//         tan: { value: '',error: false }, // TAN*
//         itr_filing_status: { value: '',error: false }, // Status of filing ITR of last 2 yrs.
//         pan_linked_aadhaar: { value: '',error: false }, // PAN linked with Aadhaar
//         tds_exemption: { value: '',error: false }, // TDS Exemption/Lower Deduction
//         tds_nature_of_service: { value: '',error: false }, // Nature of Service for TDS
//         tds_doc: { value: '',error: false },
//         tds_section: { value: '',error: false }, // TDS to be Deducted u/s
//         gst_turnover_prev_yr: { value: '',error: false }, // GST Turnover of Prev Yr.(Lakhs).
//         prev_yr: { value: '',error: false }, // Prev Yr
//         e_invoice_applicable: { value: '',error: false }, // E-Invoice Applicable
//         bank_name: { value: '',error: false }, // Bank Name.
//         ifsc_code: { value: '',error: false }, // IFSC Code
//         bank_account_number: { value: '',error: false }, // Bank Account Number
//         cheque_issued_name: { value: '',error: false }, // Cheque to be Issued in name of*
//         gstn_document: { value: '',error: false }, // GSTN Document*
//         pan_document: { value: '',error: false }, // PAN Document*
//       });


 const [formValues, setFormValues] = useState({
            firm_name: '',
            firm_status:'',
            address:'',
           //  street: '',
           //  po_box: '', 
           //  city: '',
           //  district_name: '',
           //  block_tehsil: '',
           //  main_town_village: '', 
           //  post_office: '', 
           //  police_station: '',
           //  state: '', // State*
           //  pin_code: '', // Pin Code*
           proprietor_details:'',
           //  proprietor_name: '', 
           //  proprietor_dob: '', 
           //  proprietor_email: '', 
           //  proprietor_mobile: '', 
           contact_person_details: '',
           // contact_person: '', 
           // contact_person_email: '', 
           // contact_person_mobile: '',
           // contact_person_telephone: '',
            pan: '', 
            aadhaar: '', 
            cin: '', 
            roc_status:'', 
            inpln: '', 
            mobile:'',
            email:'',
            fssai_details:'',
           //  fssi_registration_status: '', 
           //  fssi_regn_no: '', 
            gstn: '', 
            tan: '', 
            bank_details: '',
           //  bank_name: '',
           //  bank_branch_name: '',
           //  ifsc_code: '', // IFSC Code
           //  bank_account_number: '',
           //  undated_cheque_1: '',
           //  undated_cheque_2: '',
           //  undated_cheque_3: '',
           //  miscellaneous: '',
            companies: [
              { name_of_company: '', company_brand: '', monthly_turnover: '' }
            ],
            godown_details: '',
           //  godown_area: '',
           //  godown_type: '',
           //  rcc_structure: '',
           //  del_type_rickshaw:'',
           //  del_type_van:'',
           //  model_no_van:'',
           //  customer_salesman_1: '',
           //  customer_salesman_no_1: '',
           //  customer_salesman_2: '',
           //  customer_salesman_no_2: '',
           //  customer_weekoff: '',
      
            marketDetails: {
              Monday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: ""
                }
              ],
              Tuesday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: "",
                }
              ],
              Wednesday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: "",
                }
               
              ],
              Thursday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: "",
                },
              ],
              Friday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: "",
                },
              ],
              Saturday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: "",
                },
              ],
              Sunday: [
                {
                  beatName_1: "",
                  distanceFromGodown_1: "",
                  expectedDailySales_1: "",
                  retailer_1: "",
                  wholesaler_1: "",
                  frequencyOfVisit_1: "",
                  readyStockOrOrderBooking_1: "",
                  beatName_2: "",
                  distanceFromGodown_2: "",
                  expectedDailySales_2: "",
                  retailer_2: "",
                  wholesaler_2: "",
                  frequencyOfVisit_2: "",
                  readyStockOrOrderBooking_2: "",
                },
              ],
            },
          });

    useEffect(()=>{
        let cust_type= localStorage.getItem("customer_type");
        console.log("hvgdhw>> ", cust_type)
        setCustomerType(cust_type)
    },[])

      const handleCheckboxChange = (option) => {
        setSelectedOptions((prev) =>
          prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev, option]
        );
      };

      useEffect(()=>{
        fetchAllEditableFields();
      },[])

      const fetchAllEditableFields= async()=>{
                        setIsActive(true);
                        const body={
                            module: "customer",
                        }
                        console.log("body>> ", body)
                        try{
                            const response= await fetchEditable(body);
                            const res= response.data;
                            if(res.status){
                                setIsActive(false);
                                console.log("Editable fields response",res)
                                if(res.data){
                                  const filteredFormValues = Object.keys(formValues).reduce((acc, key) => {
                                    if (res.data[key] === 1) {
                                      acc[key] = formValues[key];
                                    }
                                    return acc;
                                  }, {});
                                  console.log("here is filteredform>> ", filteredFormValues)
                                  setFormValues(filteredFormValues);
                                }
                            }else{
                                console.log("Could not fetch editable fields",res);
                                if(!toast.isActive(toastId.current)){
                                    toastId.current= toast.error("Could Not fetch editable details",{
                                      className:"small-toast"
                                    })
                                  }
                                setIsActive(false);
                            }
                        }catch(error){
                            console.log("Error while fetching editable fields",error)
                            setIsActive(false);
                            if(!toast.isActive(toastId.current)){
                                toastId.current= toast.error(error.message,{
                                  className:"small-toast"
                                })
                              }
                             if(error.response?.status==403){
                                                        if(!toast.isActive(toastId.current)){
                                                          toastId.current= toast.error("Your Session has expired",{
                                                            className:"small-toast"
                                                          })
                                                        }
                                                        setTimeout(()=>{
                                                          navigate("/")
                                                          localStorage.clear();
                                                        },2000)
                                                        return;
                                                      }
                                    }
                      }
      

  const handleProceed = () => {
    if (selectedOptions.length === 0) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Please select at least one customer type", {
          className: "small-toast",
        });
      }
      return;
    }
    console.log("here are selected Options>> ", selectedOptions)
    localStorage.setItem("selected_fields", JSON.stringify(selectedOptions));
    navigate("/customer/edit/registration-form");
  };

  return (
    <>
      <ToastContainer />
      <SimpleBackdrop openLoader={isActive} />
      <div className="container">
        <div className="image-container">
          <img src={anmolLogo} alt="Business" className="business-image" />
        </div>
  
        <h2 className="title">Select The Fields You Want to Edit:</h2>
  
        <div className="checkbox-cards-container">
  {Object.keys(formValues).map((key) => {
    // Format label to be readable
    const formattedLabel = key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    return (
      <div key={key} className="checkbox-card">
        <FormControlLabel
          control={
            <Checkbox
              sx={{ color: "#01040a" }}
              checked={selectedOptions.includes(key)}
              onChange={() => handleCheckboxChange(key)}
              // disabled={customerType==="super_stockist" || customerType==="railway_distributor"}
            />
          }
          label={<span className="checkbox-label">{formattedLabel}</span>}
        />
       
      </div>
    );
  })}
</div>


  
        <Button
          variant="contained"
          sx={{ color: "ivory", marginTop: "30px" }}
          onClick={handleProceed}
          color="primary"
          className="proceed-button"
        >
          Proceed
        </Button>
      </div>
    </>
  );
}

